import { useCallback, useMemo } from 'react';
export default ({ storageArea, useStorageArea, }) => (...args) => {
    const [key] = args;
    const value = useStorageArea(...args);
    const setValue = useCallback((value) => {
        value === undefined
            ? storageArea.removeItem(key)
            : storageArea.setItem(key, value);
    }, [key]);
    return useMemo(() => [value, setValue], [value, setValue]);
};
//# sourceMappingURL=createStateHook.js.map